var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFillMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-envelope",
    clipPath: "url(#clip0_1029_1732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9693 3.69434L10.3573 9.30634C9.73158 9.93051 8.88383 10.281 8 10.281C7.11617 10.281 6.26842 9.93051 5.64267 9.30634L0.0306667 3.69434C0.0213333 3.79967 0 3.895 0 3.99967V11.9997C0.00105857 12.8834 0.352588 13.7306 0.97748 14.3555C1.60237 14.9804 2.4496 15.3319 3.33333 15.333H12.6667C13.5504 15.3319 14.3976 14.9804 15.0225 14.3555C15.6474 13.7306 15.9989 12.8834 16 11.9997V3.99967C16 3.895 15.9787 3.79967 15.9693 3.69434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.41476 8.36433L15.5041 2.27433C15.2091 1.7852 14.7931 1.38035 14.2961 1.09881C13.7991 0.817274 13.2379 0.668553 12.6668 0.666992H3.33343C2.76224 0.668553 2.20109 0.817274 1.70411 1.09881C1.20713 1.38035 0.791079 1.7852 0.496094 2.27433L6.58543 8.36433C6.96114 8.73853 7.46982 8.94864 8.00009 8.94864C8.53037 8.94864 9.03905 8.73853 9.41476 8.36433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1029_1732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillMail);
export default __webpack_public_path__ + "static/media/iconFillMail.0bc83fb69eb1b1f96c6c39c9e7b01d32.svg";
export { ForwardRef as ReactComponent };